import React from 'react'
import cn from 'classnames'

import css from './card.module.scss'

export default function(props) {
  return (
    <div className={cn(css.blogCard, props.className)}>
      <div className={css.title}>{props.title}</div>
      <p className={css.text}>{props.text}</p>
    </div>
  )
}